import Vue from "vue";
import Vuetify from "vuetify";
import "./plugins/vuetify";
import App from "./App.vue";
import "roboto-fontface/css/roboto/roboto-fontface.css";
import "material-design-icons-iconfont/dist/material-design-icons.css";
import router from "./router.js"; //* Mecanismo de rotas
import store from "./store"; //* Mecanismo de rotas
import "./assets/css/estilos.css";
import VueCookies from "vue-cookies";
import { aplicarVersaoNaUrl, salvarVersaoAtual } from "@/utils/versao";

VueCookies.config("12h", "/", "", true, "Strict");
salvarVersaoAtual(process.env.VUE_APP_VERSAO);

if (window.location.origin === new URL(window.location.href).origin) {
  const urlVersionada = aplicarVersaoNaUrl(window.location.href);
  if (urlVersionada !== window.location.pathname + window.location.search + window.location.hash) {
    window.location.replace(urlVersionada);
  }
}

import currency from "v-currency-field"; //* para entrada de valores em dinheiro
import VueTheMask from "vue-the-mask";

Vue.use(currency);
Vue.use(VueTheMask);

Vue.use(Vuetify);

Vue.config.productionTip = false;

//* Normaliza texto digitado em v-text-field / v-textarea:
//*  1. Remove caracteres de controle (exceto \t \n \r) e invisíveis Unicode:
//*       \x00-\x08  — NUL, SOH…BS
//*       \x0B-\x0C  — VT, FF
//*       \x0E-\x1F  — SO…US
//*       \x7F       — DEL
//*       \u00AD     — soft-hyphen
//*       \u200B-\u200F — zero-width space / joiners / marks
//*       \u202A-\u202E — embeddings e overrides de direção (RTL/LTR)
//*       \u2060     — word joiner
//*       \uFEFF     — BOM / zero-width no-break space
//*  2. Colapsa espaços duplos internos (preserva \n em textarea).
//*  3. Remove espaços nas extremidades (trim).
function normalizarTexto(v, multiline = false) {
  if (typeof v !== "string") return v;
  let s = v.replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x7F\u00AD\u200B-\u200F\u202A-\u202E\u2060\uFEFF]/g, "");
  if (!multiline) {
    //* Campos de linha única: converte \t \n \r em espaço antes de colapsar
    s = s.replace(/[\t\n\r]/g, " ");
  }
  return s.replace(/ {2,}/g, " ").trim();
}

//* Mixin global para v-text-field e v-textarea:
//* 1. Regras de validação recebem o valor normalizado (trim + espaços duplos).
//* 2. Ao sair do campo (blur), aplica a normalização no modelo via
//*    internalValue (setter reativo do Vuetify que emite 'input' e atualiza
//*    o v-model do pai automaticamente).
Vue.mixin({
  created() {
    const name = this.$options.name;
    if (name !== "v-text-field" && name !== "v-textarea") return;
    const multiline = name === "v-textarea";
    const originalValidate = this.validate;
    this.validate = function (force, value) {
      if (force === undefined) force = false;
      if (value === undefined) value = this.internalValue;
      return originalValidate.call(this, force, normalizarTexto(value, multiline));
    };
  },
  mounted() {
    const name = this.$options.name;
    if (name !== "v-text-field" && name !== "v-textarea") return;
    const multiline = name === "v-textarea";
    this.$on("blur", () => {
      const normalizado = normalizarTexto(this.internalValue, multiline);
      if (normalizado !== this.internalValue) {
        this.internalValue = normalizado;
      }
    });
  }
});

// Diretiva global de identificação: aceita apenas letras e dígitos (CNPJ alfanumérico / CPF)
Vue.directive("identificacao", {
  bind(el) {
    const input = el.tagName === "INPUT" ? el : el.querySelector("input");
    if (!input) return;
    const handler = () => {
      const cleaned = input.value
        .toUpperCase()
        .replace(/[^0-9A-Z]/g, "")
        .slice(0, 14);
      if (input.value !== cleaned) {
        const setter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value").set;
        setter.call(input, cleaned);
        input.dispatchEvent(new Event("input", { bubbles: true }));
      }
    };
    input.addEventListener("input", handler, true);
    el._sanitizeId = { input, handler };
  },
  unbind(el) {
    if (el._sanitizeId) {
      el._sanitizeId.input.removeEventListener("input", el._sanitizeId.handler, true);
    }
  }
});

new Vue({
  vuetify: new Vuetify(),
  router,
  store,
  render: (h) => h(App)
}).$mount("#app");
